const forgotPassword = {
    maxAttempts: import.meta.env.VITE_APP_RESET_PASSWORD_MAX_ATTEMPTS || 3,
    counterTime: import.meta.env.VITE_APP_RESET_PASSWORD_COUNTER_TIME || 30
}

export default forgotPassword
